export const TV_DISPLAY_COLLECTION = "tv-disply";
export const TV_DISPLAY_MAIN_DOC = "main";

export const TV_DISPLAY_SUBCOLLECTIONS = {
  media: "media",
  playlists: "playlists",
  celebrations: "celebrations",
  devices: "devices",
  commands: "commands",
  pairings: "pairings",
  publications: "publications",
};

export const TV_DISPLAY_MODES = {
  VIDEO_ONLY: "VIDEO_ONLY",
  IMAGE_SLIDER: "IMAGE_SLIDER",
  IMAGE_WITH_TEXT: "IMAGE_WITH_TEXT",
  VIDEO_WITH_TEXT: "VIDEO_WITH_TEXT",
  MIXED_PLAYLIST: "MIXED_PLAYLIST",
};

export const TV_DISPLAY_ORIENTATIONS = {
  LANDSCAPE: "LANDSCAPE",
  PORTRAIT: "PORTRAIT",
};

export const TV_DISPLAY_FIT_MODES = {
  CROP: "CROP",
  FIT: "FIT",
  STRETCH: "STRETCH",
};

export const TV_DISPLAY_TRANSITIONS = {
  FADE: "FADE",
  SLIDE: "SLIDE",
  ZOOM: "ZOOM",
  KEN_BURNS: "KEN_BURNS",
  SCALE_FADE: "SCALE_FADE",
  SOFT_FLASH: "SOFT_FLASH",
  RANDOM_PREMIUM: "RANDOM_PREMIUM",
};

export const TV_DEVICE_STATUSES = {
  ONLINE: "ONLINE",
  OFFLINE: "OFFLINE",
  SYNCING: "SYNCING",
  ERROR: "ERROR",
  DISABLED: "DISABLED",
  REVOKED: "REVOKED",
};

export const TV_PAIRING_STATUSES = {
  REQUESTED: "REQUESTED",
  APPROVED: "APPROVED",
  COMPLETED: "COMPLETED",
  REJECTED: "REJECTED",
  EXPIRED: "EXPIRED",
  PAIRED: "PAIRED",
  REVOKED: "REVOKED",
};

export const TV_PAIRING_TTL_MINUTES = 10;
export const TV_HEARTBEAT_INTERVAL_SECONDS = 30;
export const TV_DEVICE_ONLINE_THRESHOLD_SECONDS = 120;
export const MAX_PUBLISHED_PLAYLIST_ITEMS = 200;
export const TV_MEDIA_ACCESS_TTL_MINUTES = 60;

export const TV_PUBLICATION_STATUSES = {
  BUILDING: "BUILDING",
  READY: "READY",
  FAILED: "FAILED",
};

export const TV_PUBLISH_TARGET_MODES = {
  ALL: "ALL",
  SELECTED: "SELECTED",
};

export const TV_DELIVERY_STATUSES = {
  NEVER_PUBLISHED: "NEVER_PUBLISHED",
  WAITING_FOR_TV: "WAITING_FOR_TV",
  UPDATE_PENDING: "UPDATE_PENDING",
  UP_TO_DATE: "UP_TO_DATE",
  ERROR: "ERROR",
};

export const TV_PUBLISH_REQUEST_STATUSES = {
  IDLE: "IDLE",
  VALIDATING: "VALIDATING",
  READY: "READY",
  PUBLISHING: "PUBLISHING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

export const TV_MEDIA_TYPES = {
  VIDEO: "VIDEO",
  IMAGE: "IMAGE",
};

export const MEDIA_UPLOAD_STATUS = {
  WAITING: "WAITING",
  UPLOADING: "UPLOADING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  CANCELLED: "CANCELLED",
  READY: "READY",
};

export const SUPPORTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
];

export const SUPPORTED_VIDEO_TYPES = [
  "video/mp4",
];

export const SUPPORTED_IMAGE_EXTENSIONS = [".jpg", ".jpeg", ".png", ".webp"];
export const SUPPORTED_VIDEO_EXTENSIONS = [".mp4"];
export const TV_SUPPORTED_MEDIA_ACCEPT = [
  ...SUPPORTED_IMAGE_EXTENSIONS,
  ...SUPPORTED_VIDEO_EXTENSIONS,
].join(",");

export const MAX_IMAGE_SIZE_MB = 20;
export const MAX_VIDEO_SIZE_MB = 500;

export const TV_STORAGE_ROOT = "tv-disply";
export const TV_VIDEO_STORAGE = `${TV_STORAGE_ROOT}/videos`;
export const TV_IMAGE_STORAGE = `${TV_STORAGE_ROOT}/images`;

export const TV_DISPLAY_DEFAULT_CONFIG = {
  enabled: false,
  activePlaylistId: null,
  mode: TV_DISPLAY_MODES.VIDEO_ONLY,
  orientation: TV_DISPLAY_ORIENTATIONS.LANDSCAPE,
  transition: TV_DISPLAY_TRANSITIONS.FADE,
  slideDuration: 8,
  fitMode: TV_DISPLAY_FIT_MODES.CROP,
  videoMute: false,
  keepScreenAwake: true,
  publishedVersion: 0,
  lastPublishedPlaylistId: null,
  lastPublishedAt: null,
};

export const TV_DISPLAY_DEVICE_TEMPLATE = {
  deviceId: "",
  authUid: "",
  deviceName: "",
  notes: "",
  country: "",
  state: "",
  city: "",
  enabled: true,
  pairingStatus: TV_PAIRING_STATUSES.PAIRED,
  assignedPlaylistId: null,
  assignedPlaylistName: "",
  orientation: TV_DISPLAY_ORIENTATIONS.LANDSCAPE,
  status: TV_DEVICE_STATUSES.OFFLINE,
  currentMediaId: null,
  lastPublicationId: null,
  lastPublishedVersion: 0,
  lastAppliedPublicationId: null,
  lastAppliedVersion: null,
  lastSyncError: "",
  lastSyncErrorAt: null,
  signageMode: "STANDARD",
  isDeviceOwner: false,
  isLockTaskActive: false,
  isManagedHome: false,
  screenPolicy: "",
  playbackHealth: "STARTING",
  appVersion: null,
  manufacturer: "",
  model: "",
  androidVersion: "",
  lastSeenAt: null,
  registeredAt: null,
  pairedAt: null,
  disabledAt: null,
  revokedAt: null,
  updatedAt: null,
};

export const TV_PAIRING_TEMPLATE = {
  pairingId: "",
  pairingCode: "",
  status: TV_PAIRING_STATUSES.REQUESTED,
  deviceId: null,
  deviceName: null,
  installationId: "",
  secretHash: "",
  requestedDeviceInfo: {
    manufacturer: null,
    model: null,
    androidVersion: null,
    appVersion: null,
  },
  createdAt: null,
  expiresAt: null,
  approvedAt: null,
  completedAt: null,
  rejectedAt: null,
  approvedBy: null,
};

export const TV_PUBLICATION_TEMPLATE = {
  publicationId: "",
  requestId: "",
  playlistId: "",
  playlistName: "",
  version: 0,
  status: TV_PUBLICATION_STATUSES.BUILDING,
  scope: TV_PUBLISH_TARGET_MODES.SELECTED,
  presentation: null,
  itemCount: 0,
  targetCount: 0,
  sourcePlaylistUpdatedAt: null,
  publishedAt: null,
  createdAt: null,
  updatedAt: null,
  publishedBy: null,
};

export const TV_DEVICE_CURRENT_PUBLICATION_TEMPLATE = {
  publicationId: null,
  version: null,
  playlistId: null,
  playlistName: "",
  itemCount: 0,
  publishedAt: null,
  assignedAt: null,
  state: "UNASSIGNED",
};

export const TV_DASHBOARD_PLACEHOLDERS = [
  { key: "devices", title: "Devices", copy: "Live pairing, status, and fleet control" },
  { key: "settings", title: "Display Settings", copy: "Presentation defaults and TV configuration" },
  { key: "preview", title: "Live Preview", copy: "Draft browser preview for playlists and overlays" },
];

export const TV_MEDIA_FILTERS = {
  ALL: "ALL",
  VIDEO: "VIDEO",
  IMAGE: "IMAGE",
  ACTIVE: "ACTIVE",
  DISABLED: "DISABLED",
};

export const TV_MEDIA_SORT = {
  NEWEST: "NEWEST",
  OLDEST: "OLDEST",
  NAME_ASC: "NAME_ASC",
  NAME_DESC: "NAME_DESC",
  SIZE_ASC: "SIZE_ASC",
  SIZE_DESC: "SIZE_DESC",
};

export const TV_MEDIA_VIEW = {
  GRID: "GRID",
  LIST: "LIST",
};

export const PLAYLIST_STATUS = {
  DRAFT: "DRAFT",
  PUBLISHED: "PUBLISHED",
};

export const PLAYLIST_FILTERS = {
  ALL: "ALL",
  ACTIVE: "ACTIVE",
  DISABLED: "DISABLED",
};

export const PLAYLIST_SORT = {
  NEWEST: "NEWEST",
  OLDEST: "OLDEST",
  NAME_ASC: "NAME_ASC",
  NAME_DESC: "NAME_DESC",
};

export const DEFAULT_IMAGE_DURATION_SECONDS = 8;
export const MIN_IMAGE_DURATION_SECONDS = 3;
export const MAX_IMAGE_DURATION_SECONDS = 300;
export const DEFAULT_TRANSITION_DURATION_MS = 700;
export const MIN_TRANSITION_DURATION_MS = 300;
export const MAX_TRANSITION_DURATION_MS = 3000;
export const DEFAULT_OVERLAY_BACKGROUND_OPACITY = 0.55;

export const TV_TEXT_POSITIONS = {
  TOP_LEFT: "TOP_LEFT",
  TOP_CENTER: "TOP_CENTER",
  TOP_RIGHT: "TOP_RIGHT",
  CENTER_LEFT: "CENTER_LEFT",
  CENTER: "CENTER",
  CENTER_RIGHT: "CENTER_RIGHT",
  BOTTOM_LEFT: "BOTTOM_LEFT",
  BOTTOM_CENTER: "BOTTOM_CENTER",
  BOTTOM_RIGHT: "BOTTOM_RIGHT",
};

export const TV_TEXT_ALIGNMENTS = {
  LEFT: "LEFT",
  CENTER: "CENTER",
  RIGHT: "RIGHT",
};

export const TV_TEXT_ANIMATIONS = {
  NONE: "NONE",
  FADE_IN: "FADE_IN",
  FADE_UP: "FADE_UP",
  SLIDE_LEFT: "SLIDE_LEFT",
  SLIDE_RIGHT: "SLIDE_RIGHT",
  ZOOM_IN: "ZOOM_IN",
};

export const OFFER_TEXT_LIMITS = {
  badge: 40,
  headline: 100,
  subheadline: 160,
  priceText: 40,
  ctaText: 40,
};

export const TV_PLAYLIST_DEFAULTS = {
  enabled: true,
  loop: true,
  status: PLAYLIST_STATUS.DRAFT,
  itemCount: 0,
};

export const TV_PLAYLIST_TEXT_DEFAULTS = {
  textColor: "#FFFFFF",
  accentColor: "#FF6B00",
  backgroundColor: "#000000",
  backgroundOpacity: DEFAULT_OVERLAY_BACKGROUND_OPACITY,
  position: TV_TEXT_POSITIONS.BOTTOM_LEFT,
  textAlign: TV_TEXT_ALIGNMENTS.LEFT,
  animation: TV_TEXT_ANIMATIONS.FADE_UP,
};

export const TV_PLAYLIST_PRESENTATION_DEFAULTS = {
  displayMode: TV_DISPLAY_MODES.MIXED_PLAYLIST,
  orientation: TV_DISPLAY_ORIENTATIONS.LANDSCAPE,
  fitMode: TV_DISPLAY_FIT_MODES.CROP,
  transition: TV_DISPLAY_TRANSITIONS.FADE,
  transitionDurationMs: DEFAULT_TRANSITION_DURATION_MS,
  backgroundColor: "#000000",
  defaultImageDurationSeconds: DEFAULT_IMAGE_DURATION_SECONDS,
  showTextOverlay: true,
  textDefaults: TV_PLAYLIST_TEXT_DEFAULTS,
};

export const TV_PLAYLIST_OVERLAY_DEFAULTS = {
  enabled: false,
  badge: "",
  headline: "",
  subheadline: "",
  priceText: "",
  ctaText: "",
  ...TV_PLAYLIST_TEXT_DEFAULTS,
};

export function createTvDisplayDeviceDraft(overrides = {}) {
  return {
    ...TV_DISPLAY_DEVICE_TEMPLATE,
    ...overrides,
  };
}
